const Label = (props) => {
  return <span className='x-label'>{props.children}</span>
}

export default Label;